<template>
    <button @click="$emit('click')" class="eda-button"
            :disabled="disabled"
            :type="type"
            :class="{
             'eda-button-secondary': secondary,
             'eda-button-secondary--disabled': secondary && disabled,
             'eda-button--invisible': !visible,
             'eda-button--disabled': !secondary && disabled,
             'eda-button--hover': hover,
             'eda-button--unselected': unselected,
             'eda-button--disabled-hide': disabled && hideDisabled,
             'eda-button--error': error
            }">

        <div class="eda-button__label" :class="{'eda-button__label--hidden': loading}">
            {{ label }}
            <slot></slot>
        </div>

        <div class="eda-button__loader" :class="{'eda-button__loader--hidden': !loading}">
            <eda-ellipsis-loader :color="secondary ? 'green' : 'white'"></eda-ellipsis-loader>
        </div>

    </button>
</template>

<script>

    import EdaEllipsisLoader from "./vEllipsisLoader";

    export default {
        name: "eda-button",
        components: {
            EdaEllipsisLoader
        },
        props: {
            label: {type: String, default: ""},
            hover: {type: Boolean, default: false},
            error: {type: Boolean, default: false},
            secondary: {type: Boolean, default: false},
            visible: {type: Boolean, default: true},
            type: {type: String, default: null},
            unselected: {type: Boolean, default: false},
            loading: {type: Boolean, default: false},
            disabled: {type: Boolean, default: false},
            hideDisabled: {type: Boolean, default: false}

        }
    }
</script>

<style lang="scss">

    //noinspection CssUnknownTarget
    @import "~@/scss/main.scss";

    .eda-button {
        padding: 0.75em 2em;
        display: block;
        border-radius: 3em;
        border: none;
        outline: none;
        font-weight: 300;
        text-align: center;
        position: relative;
        color: white;
        font-size: inherit;
        background-color: #00B27C;
        cursor: pointer;
        display: flex;
        transition: all 0.4s ease;
        overflow: hidden;



        &--hover {
            background-color: lighten($primary-color, 5%);
        }
    }

    .eda-button-secondary {
        background-color: transparent;
        color: #00B27C;
        border: 1px solid #00B27C;
        margin-right: 1em;

    }

    .eda-button-secondary--disabled {
        border-color: #DDD;
        color: #DDD;
        cursor: not-allowed;

    }

    .eda-button--unselected {
        background-color: transparent;
        color: #00B27C;
        border: 1px solid #00B27C;
    }

    .eda-button--disabled {

        cursor: not-allowed;
        background-color: #EEEE;
        color: #DDD;
    }

    .eda-button--disabled-hide {
        opacity: 0;
        transform: translateY(1em);
    }

    .eda-button--invisible {
        opacity: 0;
        max-height: 0;
        padding-top: 0;

        padding-bottom: 0;

    }

    .eda-button--error {
        animation: shake 0.82s cubic-bezier(.36, .07, .19, .97) both;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
        perspective: 1000px;
    }

    .eda-button__loader {
        z-index: 0;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        position: absolute;
    }

    .eda-button__loader,
    .eda-button__button-label {
        transition: all 0.2s ease;
    }

    .eda-button__loader--hidden {
        opacity: 0;
        transform: translate(-50%, -50%) scale(0.2);
    }

    .eda-button__label--hidden {
        opacity: 0;
        transform: translateY(0em) scale(0.2);
    }

    @keyframes shake {
        10%, 90% {
            transform: translate3d(-1px, 0, 0);
        }

        20%, 80% {
            transform: translate3d(2px, 0, 0);
        }

        30%, 50%, 70% {
            transform: translate3d(-4px, 0, 0);
        }

        40%, 60% {
            transform: translate3d(4px, 0, 0);
        }
    }
</style>